import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TeamMemberTaskState, TeamMemberTask, TaskFilters } from './types'
import { fetchTeamMemberTask } from './action'

const initialState: TeamMemberTaskState = {
  data: null,
  loading: false,
  error: null,
  filters: {
    assigned: {
      status: ['active'],
      isArchived: false,
    },
    unassigned: {
      status: ['active'],
      isArchived: false,
      isCompleted: false,
    },
  },
}

const teamMemberTasksSlice = createSlice({
  name: 'teamMemberTasks',
  initialState,
  reducers: {
    setAssignedFilters: (state, action: PayloadAction<TaskFilters>) => {
      state.filters.assigned = action.payload
    },
    setUnassignedFilters: (state, action: PayloadAction<TaskFilters>) => {
      state.filters.unassigned = action.payload
    },
    resetFilters: (state) => {
      state.filters = initialState.filters
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeamMemberTask.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchTeamMemberTask.fulfilled, (state, action: PayloadAction<TeamMemberTask>) => {
        state.loading = false
        state.data = action.payload
      })
      .addCase(fetchTeamMemberTask.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export const { setAssignedFilters, setUnassignedFilters, resetFilters } = teamMemberTasksSlice.actions
export default teamMemberTasksSlice.reducer
